<template>
  <div v-if="showModal" class="modal-overlay">
    <div class="modal-content">
      <h3>股票趨勢改變通知</h3>
      <p>請注意下列股票預測已脫離上漲趨勢：</p>
      <ul>
        <li
          v-for="stock in upToDownStocks"
          :key="stock.stock_no"
          class="up-to-down"
        >
          {{ stock.stock_name }} ({{ stock.stock_no }})
        </li>
      </ul>
      <p>下列股票預測開始上漲：</p>
      <ul>
        <li
          v-for="stock in firstUpStocks"
          :key="stock.stock_no"
          class="first-up"
        >
          {{ stock.stock_name }} ({{ stock.stock_no }})
        </li>
      </ul>
      <button @click="closeModal">確定</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockNotification",
  props: {
    upToDownStocks: {
      type: Array,
      required: true,
      default: () => [],
    },
    firstUpStocks: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      isModalVisible: true,
    };
  },
  computed: {
    showModal() {
      return (
        this.isModalVisible &&
        (this.upToDownStocks.length != 0 || this.firstUpStocks.length != 0)
      );
    },
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.up-to-down {
  color: #28a745;
  font-size: 1.1em;
  font-weight: 900;
}

.first-up {
  color: #dc3545;
  font-size: 1.1em;
  font-weight: 900;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 5px 0;
}

button {
  margin-top: 15px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.1em;
  font-weight: 900;
}

button:hover {
  background-color: #0056b3;
}
</style>
